import { useLocation } from 'wouter';
import { trpc } from '../../lib/trpc';
import { useAsync } from '../../lib/useAsync';
import { Loading, ErrorBox, EmptyBox, StatusPill, PageTitle } from '../../components/admin/ui';
import { AGENTE_STATUS_LABEL, AGENTE_STATUS_COLOR } from '../../lib/format';

function Cell({ status }: { status: 'operando' | 'lento' | 'falha' | null }) {
  if (!status) return <span className="text-ink-4">-</span>;
  return <StatusPill label={AGENTE_STATUS_LABEL[status]!} color={AGENTE_STATUS_COLOR[status]!} />;
}

export function AdminSaude() {
  const [, navigate] = useLocation();
  const { data, loading, error, reload } = useAsync(() => trpc.admin.saude.query());

  return (
    <div className="mx-auto max-w-5xl">
      <PageTitle titulo="Saúde dos agentes" />

      {loading && <Loading />}
      {error && <ErrorBox msg={error} onRetry={reload} />}

      {data && data.linhas.length === 0 && (
        <EmptyBox titulo="Sem clientes monitorados" descricao="Nenhuma incorporadora ativa no momento." />
      )}

      {data && data.linhas.length > 0 && (
        <>
          {data.emFalha.length > 0 && (
            <div
              className="mb-5 flex items-center justify-between gap-4 rounded px-5 py-4"
              style={{ border: '1px solid var(--risk)', background: 'var(--risk-soft)' }}
            >
              <div className="flex items-start gap-3">
                <span
                  className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md"
                  style={{ background: 'var(--risk-soft)' }}
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                    <path d="M12 8v5m0 3h.01M10.3 3.9L2.4 18a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"
                      stroke="var(--risk)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <div>
                  <div className="text-sm font-semibold text-ink">
                    {data.emFalha.length} cliente{data.emFalha.length > 1 ? 's' : ''} com agente em falha
                  </div>
                  <div className="mt-0.5 text-sm text-ink-3">
                    {data.emFalha[0]!.nome}: {data.emFalha[0]!.detalhe ?? 'agente em falha'}
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary shrink-0"
                onClick={() => navigate(`/admin/clientes/${encodeURIComponent(data.emFalha[0]!.orgId)}`)}
              >
                Intervir
              </button>
            </div>
          )}

          <div className="card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-surface-2 text-left text-[11px] uppercase tracking-wider text-ink-4">
                <tr>
                  <th className="px-5 py-3 font-medium">Incorporadora</th>
                  <th className="px-3 py-3 font-medium">Ingestão</th>
                  <th className="px-3 py-3 font-medium">Risco</th>
                  <th className="px-3 py-3 font-medium">Comunicação</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line">
                {data.linhas.map((l) => (
                  <tr
                    key={l.orgId}
                    className="cursor-pointer hover:bg-surface-2"
                    onClick={() => navigate(`/admin/clientes/${encodeURIComponent(l.orgId)}`)}
                  >
                    <td className="px-5 py-3 font-medium text-ink">{l.nome}</td>
                    <td className="px-3 py-3"><Cell status={l.ingestao} /></td>
                    <td className="px-3 py-3"><Cell status={l.risco} /></td>
                    <td className="px-3 py-3"><Cell status={l.comunicacao} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
